function burgerMenu() {
    let header = document.querySelector(".header");
    if (header) {
        let menuIcon = header.querySelector(".menu-icon");
        let lastScrollY = window.scrollY;

        if (lastScrollY > 50) {
            document.body.classList.add("fixed");
        } else {
            document.body.classList.remove("fixed");
        }

        window.addEventListener("scroll", () => {
            if (header.classList.contains("active")) {
                return;
            }

            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY) {
                document.body.classList.remove("fixed");

                let offset = Math.min(currentScrollY, 140);
                header.style.top = `-${offset}px`;
            } else {
                header.style.top = "0px";

                if (currentScrollY > 50) {
                    document.body.classList.add("fixed");
                } else {
                    document.body.classList.remove("fixed");
                }
            }

            lastScrollY = currentScrollY;
        });

        menuIcon.addEventListener("click", function (e) {
            e.preventDefault();
            if (!header.classList.contains("active")) {
                header.style.top = "0px";
            }

            header.classList.toggle("active");
            menuIcon.classList.toggle("active");
            document.body.classList.toggle("no-scroll");
        });
    }
}
burgerMenu();
